export default __webpack_public_path__ + "static/media/Happile.65a8669b.jpg";